import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import getBundleGroups from 'store/product/selector/getBundleGroups';
import setPreventFromProceedOperation from 'store/product/operation/setPreventFromProceedOperation';
import getSelectedBundleProducts from 'store/product/selector/getSelectedBundleProducts';
import fetchBundleGroupsPricesOperation from 'store/product/operation/fetchBundleGroupsPricesOperation';
import styles from './BundleProducts.module.scss';
import BundledProductsGroup from '../BundledProductsGroup/BundledProductsGroup';

interface OwnProps {
  theme?: string;
  showDescription?: boolean;
}

const BundleProducts: FC<OwnProps> = ({ theme, showDescription = true }) => {
  const dispatch = useDispatch();
  const bundleGroups = useSelector(getBundleGroups);
  const bundledProducts = useSelector(getSelectedBundleProducts);

  useEffect(() => {
    dispatch(fetchBundleGroupsPricesOperation());
  }, [bundleGroups]);

  useEffect(() => {
    // check if bundle group requires selection are met the selected products
    let preventFromProceedNext = false;
    bundleGroups.forEach((group) => {
      if (group.canBeNotSelected === false) {
        const selectedBundleProduct = bundledProducts.find(
          (bundledProduct) => bundledProduct.bundleGroupId === group.bundleGroupId && bundledProduct.productId > 0,
        );
        if (!selectedBundleProduct) {
          preventFromProceedNext = true;
        }
      }
    });
    dispatch(setPreventFromProceedOperation(preventFromProceedNext));
  }, [bundleGroups, bundledProducts]);

  if (!bundleGroups.length) {
    return null;
  }

  return (
    <div className={styles.bundleProducts}>
      {bundleGroups.map((bundleGroup) => (
        <BundledProductsGroup
          theme={theme}
          key={`bg${bundleGroup.bundleGroupId}`}
          bundleGroup={bundleGroup}
          showDescription={showDescription}
        />
      ))}
    </div>
  );
};

export default BundleProducts;
